var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import SerpotrackAuthFrame from "../../Layout/SerpotrackAuthFrame";
import { AuthFormPanel } from "peggirkit";
import AuthFormSignIn from "./Form/AuthFormSignIn";
var SignIn = function (_a) {
    var logo = _a.logo, onSignedInRedirectTo = _a.onSignedInRedirectTo, forgotPasswordUrl = _a.forgotPasswordUrl, footer = _a.footer;
    var intl = useIntl();
    return (_jsx(SerpotrackAuthFrame, __assign({ title: intl.formatMessage({ id: "signIn" }), logo: logo, onSignedInRedirectTo: onSignedInRedirectTo }, { children: _jsx(AuthFormPanel, { form: _jsx(AuthFormSignIn, { forgotPasswordUrl: forgotPasswordUrl }), footer: footer }) })));
};
export default SignIn;
